import React, { useEffect } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { MapPin, Phone, Clock, Navigation } from 'lucide-react';
import { Button } from '../components/ui/button';

export const DisplayCentres = () => {
  // Scroll to top when page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const centres = [
    {
      id: 1,
      city: 'Karachi',
      name: 'Bernard Fan Co. Karachi Showroom',
      address: 'Suite 101, First Floor, Building no 16-C, Zulfiqar Commercial Street no 3, Phase 8, DHA',
      phone: '+92 (21) 3456-7890',
      hours: 'Mon-Sat: 11:00 AM - 7:00 PM',
      features: ['Full Product Range', 'Consultation', 'Technical Support']
    },
    {
      id: 2,
      city: 'Lahore',
      name: 'Bernard Fan Co. Lahore Showroom',
      address: 'Plaza no. 116, Block-D, phase 8 CBW, DHA',
      phone: '+92 (42) 3567-8901',
      hours: 'Mon-Sat: 11:00 AM - 7:00 PM',
      features: ['Full Product Range', 'Consultation', 'Technical Support']
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        {/* Background Image */}
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: 'url(/images/display-centres-bg.jpeg)' }}
        ></div>
        
        {/* Minimal overlay for text readability */}
        <div className="absolute inset-0 bg-stone-900/30"></div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-light tracking-tight text-white mb-6 drop-shadow-lg">
            SHOWROOMS
          </h1>
          <p className="text-xl text-white max-w-3xl mx-auto font-light leading-relaxed drop-shadow-md">
            Visit our showrooms to experience the Bernard Fan Co. collection in person
          </p>
        </div>
      </section>

      {/* Centres Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {centres.map((centre) => (
              <div key={centre.id} className="bg-stone-50 p-8 space-y-6 hover:shadow-lg transition-shadow duration-300">
                <div>
                  <h3 className="text-2xl font-light text-stone-900 mb-2">
                    {centre.city}
                  </h3>
                  <p className="text-lg text-stone-700">
                    {centre.name}
                  </p>
                </div>

                <div className="space-y-4">
                  <div className="flex items-start space-x-3">
                    <MapPin className="text-stone-600 mt-1 flex-shrink-0" size={20} />
                    <p className="text-stone-600 leading-relaxed">
                      {centre.address}
                    </p>
                  </div>

                  <div className="flex items-center space-x-3">
                    <Clock className="text-stone-600 flex-shrink-0" size={20} />
                    <p className="text-stone-600">
                      {centre.hours}
                    </p>
                  </div>
                </div>

                <div className="pt-4 border-t border-stone-200">
                  <p className="text-sm text-stone-500 uppercase tracking-wide mb-3">
                    Services
                  </p>
                  <ul className="space-y-2">
                    {centre.features.map((feature, index) => (
                      <li key={index} className="text-stone-600 flex items-center">
                        <span className="w-1.5 h-1.5 bg-stone-900 rounded-full mr-3"></span>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
          
          {/* Free Delivery Banner */}
          <div className="mt-12 text-center">
            <p className="text-2xl font-bold text-stone-900 tracking-wide">
              FREE DELIVERY ALL OVER PAKISTAN
            </p>
          </div>
        </div>
      </section>

      {/* Visit Info */}
      <section className="py-20 bg-stone-100">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold tracking-tight text-stone-900 mb-6">
            LUXURY DESIGNER FANS IN PAKISTAN
          </h2>
          <p className="text-lg text-stone-600 leading-relaxed">
            Our luxury fans are designed and manufactured to compliment your home and your every need. Made with superior materials and equipped with the latest technology, our fans bring style and aesthetics to your home. Feel the luxury in every detail when you buy our designer fans.
          </p>
          <h3 className="text-3xl font-bold tracking-tight text-stone-900 mt-8">
            CURATING INTERNATIONAL LUXURY DESIGNER FANS FOR PAKISTANI HOMES
          </h3>
          <p className="text-lg text-stone-600 leading-relaxed mt-6">
            Bernard Fan Co. brings international standards to Pakistan with features customised for the Pakistani consumer. Shop the latest luxury fans in Pakistan curated to suit your every need.
          </p>
          <h3 className="text-3xl font-bold tracking-tight text-stone-900 mt-8">
            A STRESS-FREE WAY TO SHOP DESIGNER FANS IN PAKISTAN
          </h3>
          <p className="text-lg text-stone-600 leading-relaxed mt-6">
            Our showrooms enable a smooth and hassle-free shopping experience with our in-store expert who can guide you through the selection and buying process, helping you choose the correct luxury fan for your home. Our showroom provides a rich experience with real time view and working of the products. Find a showroom near you and walk in today to experience luxury designer fans.
          </p>
          <h3 className="text-3xl font-bold tracking-tight text-stone-900 mt-8">
            THE ONLY LUXURY FAN STORE IN PAKISTAN
          </h3>
          <p className="text-lg text-stone-600 leading-relaxed mt-6">
            Our customers say we are the only luxury fan store in Pakistan and we are humbled. Our appetite for innovation and attention to detail has made us the go-to place for designer fans of all kinds. We have designer fans ranging from ceiling fans, fans with lights to wall fans.
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
};